(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kw-jp-stories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.ks-video-trigger');
  if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  let url;
  try { url = new URL(trigger.href); } catch (_) { return; }
  let videoId = '';
  if (url.hostname === 'youtu.be') videoId = url.pathname.slice(1);
  if (['youtube.com','www.youtube.com','m.youtube.com'].includes(url.hostname)) videoId = url.searchParams.get('v') || '';
  if (!/^[a-zA-Z0-9_-]{11}$/.test(videoId)) return;
  event.preventDefault();
  document.querySelectorAll('.ks-video-frame').forEach(function(frame) {
    const previous = frame.parentElement.querySelector('.ks-video-trigger');
    frame.remove();
    if (previous) previous.hidden = false;
  });
  const frame = document.createElement('iframe');
  frame.className = 'ks-video-frame';
  frame.title = trigger.getAttribute('aria-label');
  frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.allowFullscreen = true;
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  frame.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1';
  trigger.hidden = true;
  trigger.parentElement.appendChild(frame);
  frame.focus();
});

  } catch(e) { console.error(e); }
})();
})();
